import "./ProximosShowsSection.css";

const events = [
  {
    id: 1,
    date: "2026-09-10T12:00:00",
    time: "20h",
    description: "Brasil Papaya + Camerata Florianópolis",
    location:
      "Teatro Municipal de Pomerode / Centro Cultural de Pomerode – Rua Hermann Weege, 111, Centro, Pomerode/SC",
    ticketUrl:
      "https://www.sympla.com.br/evento/yakamoz-brasil-papaya-instrumental-camerata-florianopolis/3550081?algoliaID=56228ae49efa3d0de1109385a0dc746f",
  },
  {
    id: 2,
    date: "2026-09-11T12:00:00",
    time: "20h",
    description: "Brasil Papaya + Camerata Florianópolis",
    location:
      "Teatro Municipal de Itajaí – Rua Gregório Chaves, 111, Bairro Fazenda, Itajaí/SC",
    ticketUrl:
      "https://www.sympla.com.br/evento/yakamoz-brasil-papaya-instrumental-camerata-florianopolis/3550174?algoliaID=56228ae49efa3d0de1109385a0dc746f",
  },
  {
    id: 3,
    date: "2026-10-16T12:00:00",
    time: "20h",
    description: "Brasil Papaya – YAKAMOZ • Concórdia/SC",
    location:
      "Teatro Municipal Maria Luiza de Matos – Rua Ábramo Éberle, 322, Cinquentenário, Concórdia/SC",
  },
  {
    id: 4,
    date: "2026-10-17T12:00:00",
    time: "20h",
    description: "Brasil Papaya – YAKAMOZ • Joaçaba/SC",
    location:
      "Teatro da UNOESC – Rua Getúlio Vargas, 2125, Bairro Flor da Serra, Joaçaba/SC",
  },
  {
    id: 5,
    date: "2026-10-18T12:00:00",
    time: "18h",
    description: "Brasil Papaya – YAKAMOZ • Treze Tílias/SC",
    location:
      "Concha Acústica – Praça Ministro Andreas Thaler, Centro, Treze Tílias/SC",
  },
  {
    id: 6,
    date: "2026-10-22T12:00:00",
    time: "20h",
    description: "Brasil Papaya – YAKAMOZ • São Joaquim/SC",
    location:
      "Casa da Cultura – Praça Cezário Amarante, s/n, Centro, São Joaquim/SC",
  },
  {
    id: 7,
    date: "2026-10-23T12:00:00",
    time: "20h",
    description: "Brasil Papaya – YAKAMOZ • Lages/SC",
    location:
      "Teatro Marajoara – Rua Presidente Nereu Ramos, 64, Centro, Lages/SC",
  },
  {
    id: 8,
    date: "2026-10-24T12:00:00",
    time: "20h",
    description: "Brasil Papaya – YAKAMOZ • Correia Pinto/SC",
    location:
      "Centro de Eventos Alexandre Júlio Correia Pinto – Rua Padre João Nunes do Amaral, 882–958, Correia Pinto/SC",
  },
  {
    id: 9,
    date: "2026-10-30T12:00:00",
    time: "21h",
    description: "Brasil Papaya – YAKAMOZ • São Ludgero/SC",
    location:
      "Aromáticos – Rodovia SLD 401, nº 1100, Santo Antônio, São Ludgero/SC",
  },
  {
    id: 10,
    date: "2026-10-31T12:00:00",
    time: "21h30",
    description: "Brasil Papaya – YAKAMOZ • Urussanga/SC",
    location:
      "Ventuno – Rodovia SC-108, km 21, Rio Maior, Urussanga/SC",
  },
  {
    id: 11,
    date: "2026-11-01T12:00:00",
    time: "16h",
    description: "Brasil Papaya – YAKAMOZ • Capivari de Baixo/SC",
    location:
      "Parque Diamante +Energia – Capivari de Baixo/SC",
  },
];

const ProximosShowsSection = () => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    return date.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div className="proximos-shows">
      <div className="shows-section-show">
        <h2 className="shows-title">Próximos Shows</h2>

        {events.map((event) => (
          <div key={event.id} className="shows-container-show">
            <div className="shows-content-show">

              <div className="show-item-show">
                <div className="data-and-local">
                  <div className="show-text-show">
                    <div className="show-data">
                      {formatDate(event.date)} – {event.time}
                    </div>

                    <div className="show-place">
                      {event.description}
                    </div>
                  </div>
                </div>
              </div>

              <div className="show-item-show">
                <div className="show-address-show">
                  <img
                    className="icon"
                    src="location_on.svg"
                    alt="Localização"
                  />

                  <p className="local-show">
                    {event.location}
                  </p>
                </div>
              </div>

              <div className="show-item-show">
                {event.ticketUrl ? (
                  <button
                    className="buy-ticket-btn"
                    onClick={() =>
                      window.open(
                        event.ticketUrl,
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  >
                    INGRESSOS
                  </button>
                ) : (
                  <button
                    className="buy-ticket-btn"
                    type="button"
                  >
                    GRATUITO
                  </button>
                )}
              </div>

            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default ProximosShowsSection;